export default "__VITE_ASSET__EVrQU_S1__ 640w, __VITE_ASSET__Dq3gLbde__ 1024w, __VITE_ASSET__CBBqAIgZ__ 1920w";